import gql from 'graphql-tag';

import { VendorConfigsFragmentDoc as VendorConfigsFragment } from 'generated/rbi-graphql';

export const CartEntryFragment = gql`
  fragment CartEntryFragment on CartEntries {
    _id: lineId
    lineId
    image
    isDonation
    isExtra
    name
    pickerSelections
    price
    quantity
    sanityId
    type
    url
    redeemable
    vendorConfigs {
      ...VendorConfigsFragment
    }
  }

  ${VendorConfigsFragment}
`;

export default CartEntryFragment;
